import { Directive, HostListener, Input } from '@angular/core';
import { MetricsService } from 'src/app/core/metrics.service';

@Directive({
    selector: '[event-metrics]',
    standalone: true
})
export class EventMetricsDirective {
    @Input('event-metrics') event: string;
    @Input('event-metrics-data') data: Record<string, any>;

    constructor(private readonly metricsService: MetricsService) {}

    @HostListener('click')
    onClick(): void {
        this.metricsService.postMetrics(this.event, JSON.parse(JSON.stringify(this.data ?? {}))).subscribe();
    }
}
